<template>
  <div :class="`toastr-container ${type}`">
    <div class='toastr-head'>
      <div class="toastr-icon">
         <img :src="getIconType(type)" alt="icon" />
      </div>
      <div class='toastr-title'>
        {{ title }}
      </div>
      <div class='toastr-close-container'>
        <img src="@/assets/icons/close-gray.svg" alt="close" @click="removeToastr" />
      </div>
    </div>
    <div class='toastr-message'>
      <div class='toastr-text'>
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import dangerIcon from '@/assets/icons/alert-icon-danger.svg';
import warningIcon from '@/assets/icons/alert-icon-warning.svg';
import successIcon from '@/assets/icons/alert-icon-success.svg';
import infoIcon from '@/assets/icons/alert-icon-info.svg';

export default {
  props: {
    id: { type: String, required: true },
    title: { type: String, required: true },
    message: { type: String, required: true },
    type: { type: String, required: true },
    timeout: { type: Number, default: 3000 }
  },
  mounted() {
    // Remove the toast after the timeout
    console.log('taostr mounted');
    setTimeout(() => {
      this.$store.dispatch('toastr/removeToastr', this.id);
    }, this.timeout);
  },
  methods: {
    getIconType(type) {
      switch (type) {
        case 't-danger':
          return dangerIcon;
        case 't-warning':
          return warningIcon;
        case 't-success':
          return successIcon;
        case 't-info':
          return infoIcon;
        default:
          return '';
      }
    },
    removeToastr() {
      console.log('removeToastr');
      this.$store.dispatch('toastr/removeToastr', this.id);
    }
  }
};

console.log('Toastr.vue');
</script>

<style scoped>
.toastr-container {
  position: relative;
  background-color: white;
  min-height: 50px;
  max-height: 120px;
  max-width: 420px;
  min-width: 250px;
  box-shadow: 0 0px 10px -4px rgba(11, 16, 51, 0.05);
  border-radius: 5px;
  padding: 12px 16px;
  overflow: hidden;
  align-items: center;
  margin-bottom: 12px;
  border-left: 4px solid transparent;;
}

.toastr-container.t-danger {
  border-left: 6px solid #FF5252;
}
.toastr-container.t-warning {
  border-left: 6px solid #FF764A;
}
.toastr-container.t-success {
  border-left: 6px solid #18AD6F;
}
.toastr-container.t-info {
  border-left: 6px solid #4A90E2;
}

.toastr-head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  min-height: 24px;
}
.toastr-icon {
  flex: 0 1 auto;
  min-width: 24px;
  margin-right: 8px;
  height: 24px;
  align-self: flex-start;
}
.toastr-icon img {
  width: 24px;
  height: 24px;
}
.toastr-title {
  flex: 1 1 auto;
  font-size: 13px;
  font-weight: 600;
  color: #101b24;
}
.toastr-text {
  flex: 1 1 auto;
  font-size: 13px;
  color: #101b24;
}

@media screen and (max-width: 500px) {
  .toastr-text {
    margin-left: 32px;
  }
}

.toastr-close-container {
  flex: 0 1 auto;
  cursor: pointer;
  flex-basis: 24px;
  min-width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: -5px;
  margin-top: 0px;
}
.toastr-close-container img {
  height: 20px;
  width: 20px;
}

</style>
